import searchBarView from './searchBarComponent.html';
import './searchBarComponent.css';
import _ from 'lodash';

export function searchBarComponent() {
	return {
		bindings: {
			onSubmit: '&',
			searchTerm: '=',
			search: '=?',
			placeholder: '@?',
			suggesterCallback: '<',
			suggesterDebounce: '<',
		},
		controllerAs: 'vm',
		controller: searchBarComponentCtrl,
		template: searchBarView,
	};
}

export class searchBarComponentCtrl {
	constructor($timeout, $scope) {
		'ngInject';
		this.$timeout = $timeout;
		$scope.$watch('vm.search.term', (newVal, oldVal, $scope) => {
			if (newVal || newVal == oldVal) {
				return null;
			}
			this.searchTerm = newVal;
		});
		this.suggest = this.suggest.bind(this);
		this.$timeout(() => {
			this.hasApplied = !!_.get(this, 'searchTerm', false);
		});
		this.enableSearch = true;
		this.suggestions = [];
		this.suggestionNavIdx = -1;
	}

	handleSubmit() {
		this.onSubmit();
		this.hasApplied = true;
	}

	shouldEnableClear() {
		if (!this.hasApplied || !this.searchTerm) {
			return false;
		}

		return true;
	}

	clearSearch() {
		this.hasApplied = false;
		this.searchTerm = '';
		this.$timeout(() => {
			this.onSubmit();
		});
	}

	maybeSuggest(evt) {
		if (!this.suggesterCallback) {
			return;
		}
		// handle navigating between suggestions using enter, up, down
		if (evt.which === 27) {
			// ESC: hide suggestion list
			if (this.suggestions && this.suggestions.length) {
				this.$timeout(() => {
					this.suggestionNavIdx = -1;
					this.suggestions = [];
				});
			}
			return;
		} else if (evt.which === 13) {
			// ENTER: choose selected suggestion
			if (
				this.suggestionNavIdx > -1 &&
				this.suggestions &&
				this.suggestions.length > 0 &&
				this.suggestionNavIdx < this.suggestions.length
			) {
				evt.preventDefault();
				const chosen = this.suggestions[this.suggestionNavIdx];
				chosen.onClick(chosen, 'keyboard');
			} else {
				// or, if there is no selection, avoid calling evt.preventDefault()
				// so the form will submit normally
				// and note that we are submitting so in-flight XHRs won't come back after submission
				this.isSubmitting = true;
			}
			this.suggestions = [];
			this.suggestionNavIdx = -1;
			clearTimeout(this.debounceTimeout);
			this.$timeout(() => {});
			// after 500ms we allow suggestion callback again
			this.$timeout(() => (this.isSubmitting = false), 500);
			return;
		} else if (evt.which === 38) {
			// UP: subtract one from selection index
			this.$timeout(() => this.navUp());
			return;
		} else if (evt.which === 40) {
			// DOWN: add one to selection index
			this.$timeout(() => this.navDown());
			return;
		}
		// otherwise clear out navigation
		this.suggestionNavIdx = -1;
		// and only re-search every so often
		clearTimeout(this.debounceTimeout);
		this.debounceTimeout = setTimeout(this.suggest, this.suggesterDebounce || 200);
	}

	async suggest() {
		let suggestions = this.suggesterCallback(this.searchTerm);
		if (typeof suggestions === 'object' && typeof suggestions.then === 'function') {
			try {
				suggestions = await suggestions;
			} catch (e) {
				return;
			}
		}
		if (!Array.isArray(suggestions) || this.isSubmitting) {
			// possibly an XHR was aborted
			// or we just barely submitted and results are loading
			return;
		}
		this.$timeout(() => {
			this.suggestions = suggestions;
		});
	}

	navUp() {
		if (this.suggestionNavIdx > 0) {
			// selected index is already greater than 0
			this.suggestionNavIdx--;
		} else if (this.suggestions && this.suggestions.length > 0) {
			// otherwise select last item (as long as wee have some suggestions)
			this.suggestionNavIdx = this.suggestions.length - 1;
		} else {
			// index is not applicable if there are no suggestions
			this.suggestionNavIdx = -1;
		}
	}

	navDown() {
		if (!this.suggestions || this.suggestions.length === 0) {
			// index is not applicable if there are no suggestions
			this.suggestionNavIdx = -1;
		} else if (this.suggestionNavIdx >= 0 && this.suggestionNavIdx < this.suggestions.length - 1) {
			// selected index is not at last item
			this.suggestionNavIdx++;
		} else {
			// otherwise select first
			this.suggestionNavIdx = 0;
		}
	}

	onFocus() {
		if (!this.suggesterCallback) {
			// we don't do anything with suggestions if there is no callback
			return;
		}
		this.isFocused = true;
		if (!this.searchTerm || this.searchTerm.length < 2 || (this.suggestions && this.suggestions.length > 0)) {
			// We avoid initial suggest:
			// IF search term is less than 2 chars
			// OR if we already have suggestions (e.g. we clicked out of the input then back in)
			return;
		}
		this.suggest();
	}

	onBlur() {
		if (!this.suggesterCallback) {
			return;
		}
		// remove suggestion list from DOM after short timeout
		// so the suggestion div ng-click handler can propagate
		this.$timeout(() => {
			this.isFocused = false;
		}, 200);
	}
}
